import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpUtilsService} from '../_base/crud';
import {environment} from '../../../environments/environment';
import {map} from 'rxjs/operators';

const API_ZOOM_URL = `${environment.pathToAPI}/api/v1/zoom`;

@Injectable()
export class ZoomService {
    constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {
    }

    createMeeting(topic: string) {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post(API_ZOOM_URL + '/meetings', {topic}, {headers: httpHeaders}).pipe(map<any, any>((value) => {
            return value.response;
        }));
    }

    getMeeting(meetingId: number) {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.get(API_ZOOM_URL + '/meetings/' + meetingId, {headers: httpHeaders}).pipe(map<any, any>((value) => {
            return value.response;
        }));
    }

    deleteMeeting(meetingId: number) {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.delete(API_ZOOM_URL + '/meetings/' + meetingId, {headers: httpHeaders}).pipe(map<any, any>((value) => {
            return value.response;
        }));
    }

    getSignature(meetingId: number, role: number) {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post(API_ZOOM_URL + '/signatures', {meetingId, role}, {headers: httpHeaders}).pipe(map<any, any>((value) => {
            return value.response;
        }));
    }

    getToken(meetingId: number) {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.get(API_ZOOM_URL + '/meetings/' + meetingId +  '/tokens', {headers: httpHeaders}).pipe(map<any, any>((value) => {
            return value.response;
        }));
    }

    changeZoomingUI() {
        this.addZoomingClass();
        // document.getElementById('zoom-button').style.display = 'block';
        const zoomRoot = document.getElementById('zmmtg-root');
        if (zoomRoot) {
            zoomRoot.style.display = 'block';
        }
        document.body.style.width = '50%';
        const ktHeaderTopBar = document.getElementById('kt_header_topbar');
        if (ktHeaderTopBar) {
            ktHeaderTopBar.style.right = '50%';
            ktHeaderTopBar.style.height = '50px';
            ktHeaderTopBar.style.zIndex = '1';
        }
        const ktHeaderMobile = document.getElementById('kt_header_mobile');
        if (ktHeaderMobile) {
            ktHeaderMobile.style.width = '50%';
            ktHeaderMobile.style.zIndex = '1';
        }
        const ktMenuNav = document.getElementById('kt_menu_nav');
        if (ktMenuNav) {
            ktMenuNav.style.flexDirection = 'column';
            ktMenuNav.style.alignItems = 'flex-start';
            ktMenuNav.style.width = '100%';
            const lis = ktMenuNav.getElementsByTagName('li');
            for (let i = 0; i < lis.length; i++) {
                const li = lis[i] as HTMLElement;
                li.style.flexGrow = 'unset';
                li.style.width = '100%';
                li.style.alignItems = 'flex-start';
            }
            const is = ktMenuNav.getElementsByTagName('i');
            for (let j = 0; j < is.length; j++) {
                const i = is[j] as HTMLElement;
                i.style.flex = 'unset';
            }
        }
    }

    addZoomingClass() {
        this.traverseElements(document.body);
    }

    traverseElements(element: Element) {
        element.classList.add('Zooming');
        const children = element.children;
        for (let i = 0; i < children.length; i++) {
            const child = children[i];
            this.traverseElements(child);
        }
    }
}
